<template>
  <v-container fluid class="pa-0">
    <app-toolbar />
    <v-main :style="`min-height: ${$vuetify.breakpoint.height}px`">
      <router-view />
    </v-main>
  </v-container>
</template>
<script>
import Toolbar from "@/components/Toolbar.vue";

export default {
  components: {
    appToolbar: Toolbar,
  },
};
</script>
